__turbopack_context__.v({
  "about": "AppSwitcher-module-scss-module__mPm-aq__about",
  "activeBadge": "AppSwitcher-module-scss-module__mPm-aq__activeBadge",
  "description": "AppSwitcher-module-scss-module__mPm-aq__description",
  "descriptionSwap": "AppSwitcher-module-scss-module__mPm-aq__descriptionSwap",
  "dropdown": "AppSwitcher-module-scss-module__mPm-aq__dropdown",
  "menuItem": "AppSwitcher-module-scss-module__mPm-aq__menuItem",
  "row": "AppSwitcher-module-scss-module__mPm-aq__row",
  "switchHint": "AppSwitcher-module-scss-module__mPm-aq__switchHint",
  "tab": "AppSwitcher-module-scss-module__mPm-aq__tab",
  "tabs": "AppSwitcher-module-scss-module__mPm-aq__tabs",
  "tile": "AppSwitcher-module-scss-module__mPm-aq__tile",
  "tooltip": "AppSwitcher-module-scss-module__mPm-aq__tooltip",
  "trigger": "AppSwitcher-module-scss-module__mPm-aq__trigger",
});
